/** Shared app mark for nav / header bars (`public/x-tool-logo.png`). */
export function AppHeaderLogo({ className }: { className?: string }) {
  const extra = className?.trim() ?? "";
  return (
    <img
      src="/x-tool-logo.png"
      alt="XTool"
      className={extra ? `app-header-logo ${extra}` : "app-header-logo"}
      width={34}
      height={34}
      decoding="async"
    />
  );
}
